import { confluenceSessionStorageInstance as sessionStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';

export const INVITES_KEY = 'ids-invited-from-usd';

export const getCachedInvites = () => {
	const cachedInvites = sessionStorage.getItem(INVITES_KEY);
	return cachedInvites ? (JSON.parse(cachedInvites) as string[]) : [];
};

export const setCachedInvites = (invites: string[]) => {
	sessionStorage.setItem(INVITES_KEY, JSON.stringify(invites));
};

export const updateCachedInvites = (invites: string[]) => {
	const cachedInvites = getCachedInvites();
	setCachedInvites([...cachedInvites, ...invites]);
};
